import { LogoutOptions } from '@hakimo-ui/hakimo/types';
import * as Sentry from '@sentry/react';

export const GENERIC_USER_MESSAGE = 'An error occurred';
export const MISSING_ERROR_CAUSE = 'Missing error cause in response';

export function handleUnauthorized(logout: (options?: LogoutOptions) => void) {
  return async (response: Response) => {
    if (!response.ok && response.status === 401) {
      logout({ returnTo: window.location.origin });
    }

    return response;
  };
}

export async function handleResponse(response: Response) {
  if (!response.ok) {
    let res;

    try {
      res = await response.json();
    } catch (err) {
      Sentry.captureException(new Error(String(err)));
      throw new Error(GENERIC_USER_MESSAGE);
    }

    if (!res.message) {
      Sentry.captureException(new Error(MISSING_ERROR_CAUSE), res);
      throw new Error(GENERIC_USER_MESSAGE);
    }

    throw new Error(res.message);
  }

  return response;
}
